import StudentApplication from "./src/main";

/* istanbul ignore next */
StudentApplication.install = function (Vue) {
  Vue.component(StudentApplication.name, StudentApplication);
};

export default StudentApplication;
